import {
    defineStore,
} from 'pinia';

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        alarm: false,
        applications: false,
        companies: false,
        cv: false,
        matching: false,
        messages: false,
    }),
    actions: {
        set(notifications) {
            this.$patch(notifications);
        },
    },
});
